<template>
  <section id="about" class="about-mf sect-pt4 route">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="box-shadow-full">
            <div class="row">
              <div class="col-md-12">
                <div class="title-box text-center">
                  <h4
                    class="title-a"
                    style="
                      font-family: 'Libre Baskerville', serif;
                      color: #3e4095;
                      font-size: 2rem;
                    "
                  >
                    Sobre a empresa
                  </h4>
                  <p class="subtitle-a" style="font-family: 'Times new roman'">
                    Super Safra ao decorrer dos anos
                  </p>
                </div>
              </div>
              <!-- <div class="col-md-12">
                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                <img class="d-block w-100 img-fluid" src="/images/capa.png" alt="First slide">
                                <div class="carousel-caption d-none d-md-block">
                                    <h5>...</h5>
                                    <p>...</p>
                                </div>
                                </div>
                                <div class="carousel-item">
                                <img class="d-block w-100 img-fluid" src="" alt="Second slide">
                                <div class="carousel-caption d-none d-md-block">
                                    <h5>...</h5>
                                    <p>...</p>
                                </div>
                                </div>
                                <div class="carousel-item">
                                <img class="d-block w-100 img-fluid" src="" alt="Third slide">
                                <div class="carousel-caption d-none d-md-block">
                                    <h5>...</h5>
                                    <p>...</p>
                                </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div> -->
              <div class="col-md-6">
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Criação e História
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  A Super Safra nasceu em 1995 para levar soluções ao homem do
                  campo. Hoje somos um grupo formado por 7 empresas em 4 cidades
                  com mais de 180 funcionários; Super Safra Agropecuária em
                  Capelinha, Super Safra Tratores em Teófilo Otoni, Super Safra
                  Agropecuária em Taiobeiras, Super Safra Agropecuária em
                  Vitória da Conquista/BA, Super Safra Agropecuária em Teófilo
                  Otoni, Super Safra Rental em Capelinha e Distribuidor Novartis
                  em Teófilo Otoni.
                </p>
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Colaboradores
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  O quadro de pessoal é formado por profissionais com graduação
                  em agronomia, veterinária, administração de empresas,
                  economia, direito, contabilidade, marketing, mecânica, além de
                  técnicos agropecuários. Profissionais com excelência técnica,
                  bem preparados e motivados para assumir desafios, riscos e
                  atitudes inovadoras.
                </p>
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Meio ambiente
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  O Grupo Super Safra se preocupa com o meio ambiente e busca
                  equilibrar suas ações; A educação para o consumo e gestão
                  eficientes, com orientação aos produtores rurais sobre a
                  utilização correta e consciente de defensivos agrícolas.
                  Atuação no recolhimento de embalagens vazias de agrotóxicos
                  evitando a contaminação da água, animais e seres humanos.
                  Conquista da condição de posto autorizado do INPEV – Instituto
                  Nacional de Processamento de Embalagens vazias.
                </p>
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Produtos e serviços
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  Oferecemos o que há de melhor em produtos e serviços com
                  profissionalismo e comprometimento na excelência de nossas
                  atividades, tendo a tecnologia como nossa aliada.
                </p>
              </div>
              <div class="col-md-6">
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Responsabilidade Social
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  O Grupo Super Safra está sempre engajado em ações sociais,
                  porque sabe que pode fazer a diferença : Adoção de praças
                  urbanas, preservação e recuperação de nascentes, concurso de
                  desenho para o cartão de natal do Grupo Super Safra, maratonas
                  de atletismo, natal do menor carente, campanha do agasalho,
                  patrocínio e doação a entidades culturais, assistenciais e
                  rurais, são algumas das ações do grupo Super Safra.
                </p>
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  Parcerias
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  Exclusividade com as maiores empresas do país que atuam do
                  setor agropecuário, como Massey Ferguson, Syngenta, Baldan,
                  Novartis, Dupont, Stihl, Vaccinar, Sulinox, Krebs, Amanco
                  entre outras. Participamos de programas governamentais como o
                  “Mais Alimentos” e temos parcerias com Emater, IMA, Banco do
                  Brasil, Banco do Nordeste, associações rurais, Rotary Club,
                  Jequitiplan, escolas, clube de futebol e muitos outros.
                </p>
                <h4
                  class="text-uppercase font-weight-bold"
                  style="
                    margin-top: 4vh;
                    font-family: 'Libre Baskerville', serif;
                    color: #3e4095;
                  "
                >
                  ÉTICA E CONDUTA COORPORATIVA
                </h4>
                <p class="text-justify" style="font-family: 'Times new roman'">
                  Buscamos ser referência em conduta ética, repudiando a
                  corrupção e procedimentos ilegais que causem prejuízos ao
                  Grupo Super Safra, às organizações e à sociedade. Todas as
                  nossas práticas devem se pautar pelos princípios
                  organizacionais, pela lei e pelas orientações previstas neste
                  Manual de Conduta. Para decidir se uma conduta ou atividade é
                  apropriada, avalie se: <button class="btn btn-link btn-sm text-black text-decoration-none" @click.prevent="openModalCodConduta = !openModalCodConduta"> LEIA MAIS.</button>
                </p>
              </div>
              <!-- <div class="col-md-6">
                    <div class="row">
                    <div class="col-sm-6 col-md-5">
                        <div class="about-img">
                        <img src="images/me.webp" class="img-fluid rounded b-shadow-a" alt="" style="margin-left: 0px;">
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-7">
                        <div class="about-info">
                        <p><span class="title-s">Nome: </span> <span>Lucas Carvalho de Oliveira</span></p>
                        <p><span class="title-s">Atividade: </span> <span>Desenvolvedor Fullstack</span></p>
                        <p><span class="title-s">E-mail: </span> <span>lcdo2395@gmail.com</span></p>
                        <p><span class="title-s">Whatsapp: </span> <span>+55 (31) 9.9645-2137</span></p>
                        </div>
                    </div>
                    </div>
                    <div class="skill-mf">
                    <p class="title-s">Skill</p>
                    <span><i class="fab fa-html5"></i> HTML </span> <span class="float-right"> 100%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-sass"></i> SASS </span> <span class="float-right"> 75%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-php"></i> PHP </span> <span class="float-right"> 100%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-js-square"></i> JAVASCRIPT </span> <span class="float-right"> 85%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-vuejs"></i> VUE JS </span> <span class="float-right"> 65%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-npm"></i> NPM </span> <span class="float-right"> 100%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    <span><i class="fab fa-github"></i> GIT </span> <span class="float-right"> 60%</span>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="about-me pt-4 pt-md-0">
                    <div class="title-box-2">
                        <h5 class="title-left">
                        Sobre Mim
                        </h5>
                    </div>
                    <p class="lead" align="justify">
                        Formado como Técnico em Informática na Universidade Federal de Viçosa e bacharelando em Ciências 
                        da Computação nessa mesma instituição, tem como expertise Desenvolvimento Web no âmbito FullStack.
                    </p>
                    <p class="lead" align="justify">
                        Trabalhou como Comim, no Hotel Fazenda Boa Esperança, em Florestal, Minas Gerais. Estagiou como técnico
                        manutencionista de computadores, smartphones e tablets na SuporTi Computadores e Celulares. Atuou como
                        voluntário na SetApp, Empresa Júnior de Computação, da UFV, aonde foi Diretor do setor Comercial por um ano
                        e Project Manager por 1 semestre.
                        Atualmente atua como Desenvolvedor ou Design autônomo.
                    </p>
                    <p class="lead" align="justify">
                        Tem proeficiência e experiência em desenvolvimento utilizando o Framework Laravel e o Framework VUE Js.
                        Também utiliza ferramentas indispensáveis como: SaSS, NPM, Composer, dentre outras ferramentas.
                        Trabalha na construção FullStack de aplicações Web de diferentes propósitos à pedido do cliente.
                        Também atua como Designer para não ficar parado (rsrs).
                    </p>
                    </div>
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <codConduta
      :openThis="openModalCodConduta"
    ></codConduta>
  </section>
</template>
<script>
import CodConduta from "./CodConduta.vue";
export default {
    data(){
        return {
            openModalCodConduta: false,
        }
    }, components: {
      'codConduta': CodConduta
    }
};
</script>